<template>
    <c-contract-editor
        :title     = "$t('contract.lim.fulltitle')"
        :unit-data = "unitData"
        :terminate = "true"
        @store     = "onStore"
        @edit      = "onEdit"
        @start     = "onStart"
        @end       = "onEnd"
    >
     </c-contract-editor>
</template>

<script>

import CContractEditor from "@/modules/msd/company/contract/components/controls/CContractEditor.vue";
import Contract from "@/modules/msd/company/contract/service/Contract";
import Core from "@/modules/core/service/Core";

export default {
    name: "CContractLimEditor",

    components: {
        CContractEditor,
    },

    props: {
        unit: {
            default: function () {
                return {
                    contractLimStart: null,
                }
            }
        }
    },

    data: () => ({
        readonly: true,
        unitData: {
            start: null,
            end  : null,
        }
    }),

    mounted() {
        this.setData();
    },

    watch: {
        unit () {
            this.setData();
        }
    },

    methods: {
        onStore () {
            Contract.unit.saveLim(this.unit.id, this.unit.contractLimId, this.unitData).then(() => {
                this.unit.contractLimStart = this.unitData.start;
                this.unit.contractLimExpiration = this.unitData.end;
                this.unit.limTerminate = this.unitData.terminate;
                Core.message.hint(this, this.$t('contract.edit.stored'));
            });
        },

        onEdit (readonly) {
            this.readonly = readonly;
        },

        onStart (value) {
            this.unitData.start = value;
        },

        onEnd (value) {
            this.unitData.end = value;
        },

        setData () {
            this.unitData.start = this.unit.contractLimStart;
            this.unitData.end   = this.unit.contractLimExpiration;
            this.unitData.terminate = this.unit.limTerminate;
        },
    }
}
</script>

<style scoped>

</style>